var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1em","height":"1em","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M18 12.998H6a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }